/** Page sizes a list offers; the first is the default. */
export const PAGE_SIZES = [10, 25, 50, 100] as const

export function pageCount(total: number, size: number): number {
  return Math.max(1, Math.ceil(total / size))
}

/** A page that still exists after the list shrank under it. */
export function clampPage(page: number, total: number, size: number): number {
  return Math.min(Math.max(0, page), pageCount(total, size) - 1)
}

/** The 1-based rows a page shows, for "Showing 11–20 of 151". */
export function pageRange(page: number, size: number, total: number): { from: number; to: number } {
  if (total === 0) return { from: 0, to: 0 }
  const p = clampPage(page, total, size)
  return { from: p * size + 1, to: Math.min(total, (p + 1) * size) }
}

export function pageSlice<T>(rows: readonly T[], page: number, size: number): T[] {
  const p = clampPage(page, rows.length, size)
  return rows.slice(p * size, (p + 1) * size)
}

/** Whether a list shows its footer: any list with rows, as qmeter-visit-new's TablePagination does. */
export function needsPager(total: number): boolean {
  return total > 0
}

/** Page buttons to draw (1-based), 'gap' for an ellipsis; never more than seven. */
export function pageNumbers(current: number, pages: number): (number | 'gap')[] {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1)
  if (current <= 3) return [1, 2, 3, 4, 'gap', pages]
  if (current >= pages - 2) return [1, 'gap', pages - 3, pages - 2, pages - 1, pages]
  return [1, 'gap', current - 1, current, current + 1, 'gap', pages]
}
